import { BrowserRouter, Routes, Route } from "react-router-dom";
import { EmployeeAuthGuard } from "@/components/employee/employee-auth-guard";
import { EmployerAuthGuard } from "@/components/employer/employer-auth-guard";
import { EmployeeLayout } from "@/layouts/EmployeeLayout";
import { EmployerLayout } from "@/layouts/EmployerLayout";
import HomePage from "@/pages/HomePage";
import EmployeeLoginPage from "@/pages/employee/EmployeeLoginPage";
import EmployeeDashboardPage from "@/pages/employee/EmployeeDashboardPage";
import EmployeeLeavePage from "@/pages/employee/EmployeeLeavePage";
import EmployeeHoursPage from "@/pages/employee/EmployeeHoursPage";
import EmployeeTasksPage from "@/pages/employee/EmployeeTasksPage";
import EmployeePerformancePage from "@/pages/employee/EmployeePerformancePage";
import EmployeeNotificationsPage from "@/pages/employee/EmployeeNotificationsPage";
import EmployeeProfilePage from "@/pages/employee/EmployeeProfilePage";
import EmployerLoginPage from "@/pages/employer/EmployerLoginPage";
import EmployerDashboardPage from "@/pages/employer/EmployerDashboardPage";
import EmployerEmployeesPage from "@/pages/employer/EmployerEmployeesPage";
import EmployerEmployeeDetailPage from "@/pages/employer/EmployerEmployeeDetailPage";
import EmployerLeavePage from "@/pages/employer/EmployerLeavePage";
import EmployerTasksPage from "@/pages/employer/EmployerTasksPage";
import EmployerHoursPage from "@/pages/employer/EmployerHoursPage";
import EmployerAwardsPage from "@/pages/employer/EmployerAwardsPage";
import EmployerSettingsPage from "@/pages/employer/EmployerSettingsPage";
import EmployerReportsPage from "@/pages/employer/EmployerReportsPage";
import EmployerCalendarPage from "@/pages/employer/EmployerCalendarPage";
import EmployerAuditPage from "@/pages/employer/EmployerAuditPage";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />

        <Route path="/employee/login" element={<EmployeeLoginPage />} />
        <Route element={<EmployeeAuthGuard />}>
          <Route path="/employee" element={<EmployeeLayout />}>
            <Route index element={<EmployeeDashboardPage />} />
            <Route path="tasks" element={<EmployeeTasksPage />} />
            <Route path="leave" element={<EmployeeLeavePage />} />
            <Route path="hours" element={<EmployeeHoursPage />} />
            <Route path="performance" element={<EmployeePerformancePage />} />
            <Route path="notifications" element={<EmployeeNotificationsPage />} />
            <Route path="profile" element={<EmployeeProfilePage />} />
          </Route>
        </Route>

        <Route path="/employer/login" element={<EmployerLoginPage />} />
        <Route element={<EmployerAuthGuard />}>
          <Route path="/employer" element={<EmployerLayout />}>
            <Route index element={<EmployerDashboardPage />} />
            <Route path="employees" element={<EmployerEmployeesPage />} />
            <Route path="employees/:id" element={<EmployerEmployeeDetailPage />} />
            <Route path="leave" element={<EmployerLeavePage />} />
            <Route path="tasks" element={<EmployerTasksPage />} />
            <Route path="hours" element={<EmployerHoursPage />} />
            <Route path="awards" element={<EmployerAwardsPage />} />
            <Route path="settings" element={<EmployerSettingsPage />} />
            <Route path="reports" element={<EmployerReportsPage />} />
            <Route path="calendar" element={<EmployerCalendarPage />} />
            <Route path="audit" element={<EmployerAuditPage />} />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
